export function updateAverageScore(
  currentAverage: number | null,
  timesTested: number,
  latestScore: number
) {
  if (currentAverage === null) {
    return latestScore;
  }

  if (timesTested > 0) {
    return (currentAverage * (timesTested - 1) + latestScore) / timesTested;
  }

  return null;
}
